// Frases motivacionales curadas para el banner del progreso físico. Cada una lleva su autor como
// cita (para no abusar de la obra ajena); si no tiene autor conocido, se atribuye a OTRIX.
// Sentence case, sin em-dash. El cliente también puede escribir la suya (se guarda local).
const MOTIVATIONAL_PHRASES = [
  { text: 'Qué vergüenza envejecer sin haber visto la belleza y la fuerza de la que tu cuerpo es capaz.', author: 'Sócrates' },
  { text: 'Somos lo que hacemos repetidamente. La excelencia no es un acto, sino un hábito.', author: 'Aristóteles' },
  { text: 'Cuida tu cuerpo. Es el único lugar que tienes para vivir.', author: 'Jim Rohn' },
  { text: 'La disciplina es el puente entre las metas y los logros.', author: 'Jim Rohn' },
  { text: 'La fuerza no nace de la capacidad física, sino de una voluntad indomable.', author: 'Mahatma Gandhi' },
  { text: 'No es la montaña lo que conquistamos, sino a nosotros mismos.', author: 'Edmund Hillary' },
  { text: 'Que tu alimento sea tu medicina y tu medicina sea tu alimento.', author: 'Hipócrates' },
  { text: 'El éxito es la suma de pequeños esfuerzos repetidos día tras día.', author: 'Robert Collier' },
  { text: 'Lo que no te mata te hace más fuerte.', author: 'Friedrich Nietzsche' },
  { text: 'Empieza donde estás, usa lo que tienes, haz lo que puedas.', author: 'Arthur Ashe' },
  { text: 'El que tiene un porqué para vivir puede soportar casi cualquier cómo.', author: 'Friedrich Nietzsche' },
  { text: 'El cuerpo logra lo que la mente cree.', author: 'OTRIX' },
  { text: 'El dolor de hoy es la fuerza de mañana.', author: 'OTRIX' },
  { text: 'Caer está permitido; levantarse es obligatorio.', author: 'OTRIX' },
  { text: 'Compite contra quien eras ayer.', author: 'OTRIX' }
];

export default MOTIVATIONAL_PHRASES;
